module.exports = __webpack_public_path__ + "static/media/lumbering22.8ad81c71.jpg";